import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

export const useOpacitySlide = ({
    imgList,
    time,
    autoPlay,
}: {
    imgList: Array<{ [key: string]: string }>;
    time: number;
    autoPlay: boolean;
}) => {
    const [currentIdx, setCurrentIdx] = useState(0);
    const [isPlaying, setIsPlaying] = useState(autoPlay);
    const { ref, inView } = useInView({ threshold: 0.9 });
    const [touchStart, setTouchStart] = useState(0); // 터치 시작 위치
    const [touchEnd, setTouchEnd] = useState(0); // 터치 종료 위치

    const nextSlide = () => {
        setCurrentIdx((prev) => (prev === imgList.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrentIdx((prev) => (prev === 0 ? imgList.length - 1 : prev - 1));
    };

    const handleTouchStart = (e: React.TouchEvent) => {
        setTouchStart(e.touches[0].clientX);
    };

    const handleTouchEnd = (e: React.TouchEvent) => {
        setTouchEnd(e.changedTouches[0].clientX);
        if (touchStart - touchEnd > 100) {
            // 왼쪽으로 스와이프
            nextSlide();
        }
        if (touchEnd - touchStart > 100) {
            // 오른쪽으로 스와이프
            prevSlide();
        }
    };

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;

        if (isPlaying && inView) {
            interval = setInterval(() => {
                nextSlide();
            }, time);
        } else if (interval && !inView) {
            clearInterval(interval);
        }

        return () => {
            if (interval) clearInterval(interval);
        };
    }, [isPlaying, nextSlide, prevSlide, inView]);

    const playAuto = () => {
        setIsPlaying(true);
    };

    const stopAuto = () => {
        setIsPlaying(false);
    };

    return {
        currentIdx,
        nextSlide,
        prevSlide,
        playAuto,
        stopAuto,
        isPlaying,
        ref,
        handleTouchStart,
        handleTouchEnd,
    };
};
